<template>
  
  <v-container fluid>

    <v-layout row my-3>
      <v-flex xs12>

        <v-toolbar color="primary" dark flat>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn flat exact :to="{name: 'admin-dashboard'}">Dashboard</v-btn>
            <v-btn flat exact :to="{name: 'admin-inventory'}">Inventory</v-btn>
            <v-btn flat exact :to="{name: 'admin-users'}" v-if="isAdmin">Users</v-btn>
          </v-toolbar-items>
          <v-spacer></v-spacer>
        </v-toolbar>

        <!--<v-tabs 
          fixed-tabs 
          v-model="tab"
          color="transparent"
        >
          <v-tabs-slider color="black"></v-tabs-slider>

          <v-tab exact :to="{name: 'admin-dashboard'}">
            Dashboard
          </v-tab>
          <v-tab exact :to="{name: 'admin-inventory'}">
            Inventory
          </v-tab>
        </v-tabs>-->

      </v-flex>
    </v-layout>

    <transition name="fade-up" mode="out-in" appear>
      <router-view></router-view>
    </transition>
  </v-container>

</template>

<script>

export default {
  name: 'Admin',
  data () {
    return {}
  },
  mounted: function() {
    this.checkRoute();
  },
  watch: {
    '$route': {
      handler: function(newVal, oldVal) {
        this.checkRoute();
      },
      deep: true
    }
  },
  computed: {
    cdn: function() {
      return this.$root.cdn;
    },
    user: function() {
      return this.$store.getters.user;
    },
    isAdmin: function() {
      return this.$store.getters.isAdmin;
    },
    isStylist: function() {
      return this.$store.getters.isStylist;
    }
  },
  beforeDestroy: function() {
    this.$root.drift_api.widget.show();
  },
  methods: {
    checkRoute: function() {
      if(!this.isStylist && !this.isAdmin) {
        this.$router.replace({name: 'account-trips'});
        return;
      }
      if(this.$route.name == 'admin') {
        this.$router.replace({name: 'admin-dashboard'});
        return;
      }
      if(this.$route.name == 'admin-users' && !this.isAdmin) {
        this.$router.replace({name: 'admin-dashboard'});
        return;
      }

      this.$root.drift_api.widget.hide();
    }
  }
}
</script>
